import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=f13fcdea&scoped=true&"
import script from "./Policy.vue?vue&type=script&lang=ts&"
export * from "./Policy.vue?vue&type=script&lang=ts&"
import style0 from "./Policy.vue?vue&type=style&index=0&id=f13fcdea&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13fcdea",
  null
  
)

export default component.exports